export default __webpack_public_path__ + "static/media/hershey.e27c2b81.png";